// IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p038, дефект Igor ≈22:30Z: быстрая панель ⚙ «Заголовки: Всі» — таблица очистилась, ни строк, ни колонок).
// Смена headersVisibility пересоздаёт wijmo вложенного грида (AttrGrid.set_viewParam: visibility false → nextTick → true, v-if на wj-flex-grid). Между снятием прежнего
// экземпляра и initialized нового this.flex указывает на РАЗРУШЕННЫЙ FlexGrid (dispose: disposed = true, _selHdl = null), а его геттер selection бросает TypeError
// («Cannot read properties of null (reading 'selection')»). Шаблон AttrGrid читал выделение в выражении подсказки кнопки 🏷 (cellFormTag_here) — рендер падал,
// новый wj-flex-grid не монтировался: пустое поле у ЛЮБОГО грида с кнопкой 🏷 (проба dev02: шахматка горизонтов; проба dev: обычный грид dataSheet).
// flexAlive(f): экземпляр жив (не разрушен, есть хост). liveSelection(f): выделение живого грида или null (без исключений).
export function flexAlive(f) {
    return !!f && !f.disposed && !!f.hostElement
}
export function liveSelection(f) {
    if (!flexAlive(f)) return null
    try { return f.selection || null } catch (e) { return null }
}
// rehookStep(flex, hooked): что делать обёртке шахматки с текущим flex вложенного грида — 'wait' (нет / разрушен: новый ещё не initialized),
// 'skip' (этот экземпляр уже подцеплен), 'hook' (новый: подцепить обработчики и перерисовать)
export function rehookStep(flex, hooked) {
    if (!flexAlive(flex)) return 'wait'
    return hooked && typeof hooked.has === 'function' && hooked.has(flex) ? 'skip' : 'hook'
}
